import { cx } from '@emotion/css';
import { useBreakpoints } from '@phoenix/design-system/frontend/ui/breakpoints/use-breakpoints';

import { useFeedback } from '../feedback';
import { CopyrightSection } from './copyright-section';
import { FooterSection } from './footer-section';
import { Section } from '../../domain/static-content/static-content.static-generation.model';

export interface FooterProps {
  sectionLinks: Section[] | null;
  legalEntity: string;
  minimal: boolean;
}

export function Footer({ sectionLinks: sections, legalEntity, minimal }: FooterProps) {
  const { active: feedbackActive, showFeedbackBanner } = useFeedback();
  const { lg } = useBreakpoints();
  const feedbackBannerOnMobileVisible = feedbackActive && !lg && showFeedbackBanner;

  return (
    <footer
      data-testid="footer"
      className={cx('border-t-2 border-primary-orange bg-secondary-light pb-6 pt-9 print:hidden', {
        'mb-16': feedbackBannerOnMobileVisible,
      })}
    >
      <div className="grid grid-cols-12 gap-6 stihl-page-container mb-12">
        {sections?.map(
          (section, i) =>
            !(minimal && i > 0) && (
              <FooterSection
                key={section.title || i}
                section={section}
                minimal={minimal}
                className={cx(i === 0 && 'md:col-span-8', i === 1 && 'md:col-start-10 md:col-span-3 lg:col-span-4')}
              />
            )
        )}
      </div>
      <CopyrightSection legalEntity={legalEntity} />
    </footer>
  );
}

export default Footer;
